import React, {Component} from "react";
import {Link} from 'react-router-dom';

class Popular extends Component {
	state = {
		isOpen    : false,
	};

	constructor(props) {
		super(props);
		this.openCloseHandler = this.openCloseHandler.bind(this);
	}

	openCloseHandler() {
		this.setState({
			isOpen : !this.state.isOpen
		});
	}

	render() {
		let uniqueId = `${this.props.sport.id}_${this.props.popular.id}`;

		return (
			<li onClick={this.openCloseHandler}>
				<div className={`first-level ${this.state.isOpen ? 'opened' : ''}`}>
					<input type="checkbox" id={uniqueId} value={uniqueId} onChange={this.props.handleChange}/>
					<label htmlFor={uniqueId}>
						<Link to={`/popular/${this.props.sport.slug}/${this.props.popular.slug}`}>{this.props.popular.name}</Link>
					</label>
					<span className="open-close"><i className={`fas fa-chevron-down ${this.state.isOpen ? 'rotate' : ''}`}></i></span>
				</div>

				{this.props.leagues.map(league =>
					<div className={`second-level ${this.state.isOpen ? 'show' : ''}`} key={league.id}>
						<Link to={`/line-leagues/${league.id}`}>{league.name}</Link>
					</div>
				)}
			</li>
		);
	}
}

export default Popular;


// WEBPACK FOOTER //
// ./src/app/components/TopEvents/Popular.js